export default __webpack_public_path__ + "static/media/testimonial-image2.04c4d032.jpeg";